let create = function (category, data) {
  return {
    title: {
      subtext: this.config.SubTitle || "",
      left: "center"
    },
    legend: {
      top: '5%',
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },


    legend: {
      orient: "vertical",
      left: 4,
      top: 10,
      data: category,
      selected: category.map(c => {
        return { [c]: true };
      })
    },
    series: [
      {
        name: this.config.FieldTitle || "数据",
        type: "pie",
        radius: "70%",
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        itemStyle: {
          borderRadius: 5
        },
        labelLine: {
          show: false
        },
        data: data.map((d, index) => {
          return { name: category[index], value: d };
        }),
        emphasis: {
          label: {
            show: true,
            fontSize: 40,
            fontWeight: 'bold'
          }
        },
      }
    ]
  };
};


export default { create };
